// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'disc-document';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6.556 5.848c3.052 0 5.525-1.078 5.525-2.408 0-1.33-2.473-2.409-5.525-2.409-3.051 0-5.525 1.079-5.525 2.409 0 1.33 2.474 2.408 5.525 2.408zm5.525-.354V3.44' />
    <path d='M1.031 3.44v3.683c0 1.346 2.48 2.408 5.525 2.408.496 0 .992 0 1.417-.07' />
    <path d='M1.031 7.123v3.683c0 1.346 2.48 2.409 5.525 2.409.496 0 .992 0 1.417-.071m8.996 3.116c0 .425-.284.709-.709.709h-5.666c-.425 0-.709-.283-.709-.708V8.469c0-.425.284-.708.709-.708h3.966c.142 0 .355.07.425.141l1.7 1.417c.142.141.284.354.284.566zm-4.604-5.666h2.125m-2.125 2.125h2.125m-2.125 2.125h1.062' />
  </g>
);

export const viewBox = '0 0 18 18';
